import { OnInit, EventEmitter, Directive } from "@angular/core";
import { BaseComponent, UserService, StorageService, EventBusService, StorageKeys, WindowService } from "@mypxplat/xplat/core";
import { takeUntil } from "rxjs/operators";

@Directive()
export abstract class VideoPlayerBaseComponent extends BaseComponent implements OnInit {
  public video: any;
  public videoReady = true;
  public videoInitted: EventEmitter<any> = new EventEmitter();
  public minimized: boolean = false;

  constructor(
    public _storageService: StorageService,
    userService: UserService,
    public eventBusService: EventBusService
  ) {
    super(userService);
  }

  get url() {
    // Autoplay policy: browsers block UNMUTED cross-origin autoplay without user activation. For
    // recorded videos we set `muted: true` on the video object; for livestreams we intentionally
    // don't, because the viewer has already committed by sitting through the countdown and we'd
    // rather sound plays (or the browser politely pauses and shows a play button) than force a
    // manual unmute step every time.
    const vimeoAutoplay = "&amp;autoplay=1";
    const vimeoMuted = this.video.muted ? "&amp;muted=1" : "";
    const youtubeMuted = this.video.muted ? "&mute=1" : "";
    if (this.video.platform) {
      return this.video.platform == "youtube"
        ? "https://www.youtube.com/embed/" + this.video.platform_id + "?autoplay=1&enablejsapi=1" + youtubeMuted
        : "https://player.vimeo.com/video/" + this.video.platform_id + "?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=173584" + vimeoAutoplay + vimeoMuted;
    } else {
      return this.video.type == "youtube"
        ? "https://www.youtube.com/embed/" + this.video.id + "?autoplay=1&enablejsapi=1" + youtubeMuted
        : "https://player.vimeo.com/video/" + this.video.id + "?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=173584" + vimeoAutoplay + vimeoMuted;
    }
  }

  ngOnInit() {
    this.eventBusService
      .observe(this.eventBusService.types.playVideo)
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        if (!result) return;

        // Allow switching to a different video while the player is already open.
        // Inline-video chips (comment + reply) emit playVideo; without this the
        // player ignored subsequent events and kept the previous video/comments.
        const samePresonusId = !!(result.presonus_id && this.video?.presonus_id && result.presonus_id === this.video.presonus_id);
        const samePlatformId = !!(result.id && this.video?.id && result.id === this.video.id);
        const isSameVideo = !!this.video && (samePresonusId || samePlatformId);
        if (!isSameVideo) {
          this.videoReady = false;
          this.video = result;
          this.videoReady = true;
          this.minimized = false;
          this.videoInitted.next(result);
        }
      });
  }
}
